// Port of api/fuel/app/classes/controller/api/monty/presets.php
import DB from 'offline/db'
export default function(params) {
	var userId = params.sessionUserId || DB.meta('sync_user_id')
	var presets = userId ? DB.query('SELECT * FROM preset WHERE user_id = ?', [userId]) : []
	var mapped = presets.map(function(p) {
		return { id: p.preset_id, type: p.preset_type, name: p.preset_name, filter: p.preset_filter ? (typeof p.preset_filter === 'string' ? JSON.parse(p.preset_filter) : p.preset_filter) : {}, default: p.preset_default }
	})
	return Promise.resolve({ session: { offline: true }, data: { presets: mapped } })
}
